<template>
  <div id="nav">
    <div class="nav-header">
      <img src="../assets/images/logo.png" height="20px" alt="中设国际会展" />
      <button class="btn-nav" @click="toggleShow">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
    </div>

    <div class="nav-content" :class="[isShowNavList ? 'showNav' : 'hideNav']">
      <div class="nav-close" @click="toggleShow">
        <img src="../assets/image/close.png" />
      </div>
      <ul class="nav-list">
        <li class="nav-item">
          <a @click="goTo('/')" class="item-anchor">首页</a>
        </li>
        <li class="nav-item">
          <a @click="goTo('/about')" class="item-anchor">关于中设</a>
        </li>
        <li class="nav-item">
          <a
            @click="
              openPdf(
                'https://miniapp.static.zhongsheyun.com/%E4%B8%AD%E8%AE%BE%E9%9B%86%E5%9B%A2%E5%AE%98%E7%BD%91/%E9%9B%86%E5%9B%A2%E7%94%BB%E5%86%8C.pdf'
              )
            "
            class="item-anchor"
            >集团画册</a
          >
        </li>
        <li class="nav-item">
          <a
            @click="
              openPdf(
                'https://miniapp.static.zhongsheyun.com/%E4%B8%AD%E8%AE%BE%E9%9B%86%E5%9B%A2%E5%AE%98%E7%BD%91/%E5%B1%95%E9%99%88%E9%83%A8%E5%AE%A3%E4%BC%A0%E6%89%8B%E5%86%8C.pdf'
              )
            "
            class="item-anchor"
            >展陈画册</a
          >
        </li>
        <!-- <li class="nav-item">
          <a @click="goTo('/join')" class="item-anchor">加入我们</a>
        </li> -->
        <li class="nav-item">
          <a @click="handelClick()" class="item-anchor">今市数字会展平台</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowNavList: false,
    };
  },
  methods: {
    handelClick() {
      const link = "https://m.jinshi.online/";
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        window.location.href = link;
      } else window.open(link, "_blank");
    },
    toggleShow() {
      this.isShowNavList = !this.isShowNavList;
    },
    async goTo(path) {
      this.$router.push({ path });
      this.toggleShow();
      return;
    },
    // 是否安卓
    isAndroid() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      return isAndroid;
    },
    openPdf(url) {
      if (!this.isAndroid()) {
        window.open(url, "_blank");
        this.toggleShow();
        return;
      }
      this.$router.push({ path: "/pdf", query: { url } });
      this.toggleShow();
    },
  },
};
</script>

<style lang='scss'>
#nav {
  background: rgba(255, 255, 255, 0.6);
  // 导航头部
  .nav-header {
    padding: 4px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      z-index: 1;
    }
    // 导航按钮样式
    .btn-nav {
      background: transparent;
      border: none;
      padding: 10px;
      -webkit-transition: all 0.5s ease;
      -moz-transition: all 0.5s ease;
      -ms-transition: all 0.5s ease;
      -o-transition: all 0.5s ease;
      transition: all 0.5s ease;
      cursor: pointer;
      z-index: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      .icon-bar {
        display: block;
        margin: 2px 0;
        width: 16px;
        height: 0;
        border: 1px solid #0068b7;
      }

      // .icon-bar::before {
      //   content: "";
      //   width: 3px;
      //   height: 3px;
      //   background: #0068b7;
      //   position: absolute;
      //   left: 2px;
      //   border-radius: 40%;
      // }
    }

    .btn-nav:focus {
      outline: 0;
    }
  }
}
// 导航内容
.nav-content {
  position: fixed;
  top: -100%;
  bottom: 0;
  left: 0;
  right: 0;
  background: #000000;
  display: block;
  height: 100%;
  z-index: 9;
  .nav-close {
    text-align: right;
    padding: 22px;
  }
  .nav-list {
    padding: 0;
    position: relative;
    .nav-item {
      margin: 16px auto;
      text-align: center;
      .item-anchor {
        color: #fff;
        font-size: 22px;
        text-transform: uppercase;
        position: relative;
        text-decoration: none;
        padding: 10px;
      }
      .item-anchor:after {
        content: "";
        position: absolute;
        width: 3px;
        height: 3px;
        left: 0;
        bottom: 0;
        z-index: 9;
        background: transparent;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -ms-transition: all 1s ease;
        -o-transition: all 1s ease;
        transition: all 1s ease;
      }

      .item-anchor:hover,
      .item-anchor:focus {
        color: #fca311;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -ms-transition: all 1s ease;
        -o-transition: all 1s ease;
        transition: all 1s ease;
      }

      .item-anchor:hover:after,
      .item-anchor:focus:after {
        width: 100%;
        background: #fca311;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -ms-transition: all 1s ease;
        -o-transition: all 1s ease;
        transition: all 1s ease;
      }
    }
  }
}

.icon-bar {
  -webkit-transition: all 0.7s ease;
  -moz-transition: all 0.7s ease;
  -ms-transition: all 0.7s ease;
  -o-transition: all 0.7s ease;
  transition: all 0.7s ease;
  z-index: 999999;
}

@keyframes showNav {
  from {
    top: -100%;
  }

  to {
    top: 0;
  }
}

@-webkit-keyframes showNav {
  from {
    top: -100%;
  }

  to {
    top: 0;
  }
}

@-moz-keyframes showNav {
  from {
    top: -100%;
  }

  to {
    top: 0;
  }
}

@-o-keyframes showNav {
  from {
    top: -100%;
  }

  to {
    top: 0;
  }
}

.showNav {
  -webkit-animation: showNav 1s ease forwards;
  -moz-animation: showNav 1s ease forwards;
  -o-animation: showNav 1s ease forwards;
  animation: showNav 1s ease forwards;
}
</style>